import React, {useEffect} from "react";
import Link from "../utils/link";
import {Darling, Group, Observatory} from "./icons";
import {Instagram, Facebook, Linkedin, Tiktok} from "./icons";
import {gsap} from "gsap";

const Footer = () => {

    useEffect(() => {
        const logoAnimation = gsap.timeline({repeat: -1, repeatDelay: 5});

        logoAnimation
            .to('.logo--close', {
                visibility: 'visible',
                opacity: 1,
                duration: 0.2,
                ease: 'power1.inOut',
            })
            .to('.logo--close', {
                visibility: 'hidden',
                opacity: 0,
                duration: 0.2,
                ease: 'power1.inOut'
            });
    }, []);

    return (
        <div className="footer">
            <div className='footer__inner'>
                <div className='footer__top'>
                    <div className="logo">
                        <div className="logo--word">
                            <Observatory/>
                        </div>
                    </div>
                </div>

                <div className='footer__middle'>
                    <div className='footer__time'>
                        <ul>
                            <li>OPEN DAILY <br/> 8am - 4pm</li>
                        </ul>
                    </div>

                    <div className='footer__location'>
                        <Link target='_blank' to='https://maps.app.goo.gl/7t217Edh4FwdmAqE8'>Royal Botanic Gardens Melbourne</Link>
                        <Link target='_blank' to='https://maps.app.goo.gl/7t217Edh4FwdmAqE8'>100 Birdwood Avenue<br />Melbourne VIC 3004</Link>
                        <Link to='mailto:eat@theobservatory.melbourne'>eat@theobservatory.melbourne</Link>
                        <Link to='tel:+61399484991'>03 9948 4991</Link>
                    </div>

                    <div className='footer__nav'>
                        <div className='footer__social'>
                            <h3>Socials</h3>
                            <ul>
                                <li><Link to='https://www.instagram.com/theobservatory.melb/?hl=en'><Instagram/></Link></li>
                                <li><Link to='https://www.facebook.com/people/The-Observatory/61575569662159/'><Facebook/></Link></li>
                                <li><Link to='https://www.tiktok.com/@theobservatory.melb?lang=en'><Tiktok/></Link></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className='footer__bottom'>
                    <div className='footer__bottom--logo'>
                        <Link target='_blank' to='https://darlinggroup.com.au/'>
                            <Darling/>
                            <Group/>
                        </Link>
                    </div>

                    <div className='footer__credit'>
                        <div className='footer__col'>
                            <p>© 2026 Darling Group. All rights reserved.</p>
                        </div>

                        <div className='footer__res'>
                            <ul>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/cheri/'>Chéri</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/higher-ground/'>Higher Ground</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/terrace/'>Terrace</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/top-paddock/'>Top paddock</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/kettle-black/'>Kettle Black</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/token/'>Token</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/darling/'>Darling</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/dundas-faussett/'>Dundas & Faussett</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/bambu/'>Bambu</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/stringers/'>Stringers</Link></li>
                                <li><Link target='_blank' to='https://darlinggroup.com.au/the-observatory/'>The Observatory</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;